import React, { useState } from "react";
import { AddAdminWrapper, ViewAdminWrapper } from "./style";
import Config from "../../utils/config";
import { Heading, ButtonSolid } from "../styledConstants";
import MaterialInput from "../common/UI/MaterialInput";
import ErrorMessage from "../ErrorMessage";
import SuccessMessage from "../SuccessMessage";
import { formValidation } from "../../utils/formValidation";
import ApiRequest from "../../utils/ApiRequest";
import { Card, Button } from "../../v2/design-system";
import { theme } from "../../v2/design-system/theme";

export default function ProgramManagerForm({ setProgramManagerId, variant = "v1" }) {
  const isV2 = variant === "v2";
  const formField = {
    programManagerName: "",
    programManagerCode: "",
    consentRequired: "",
    cashbackRequired: false,
  };

  const [formData, updateFormData] = useState({ ...formField });
  const [formErrors, setFormErrors] = useState({});
  const [message, setMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [dataset, setDataSet] = useState("");

  const handleFormDataChange = (eOrValue, name) => {
    if (eOrValue && eOrValue.target) {
      const { name: fieldName, value } = eOrValue.target;
      updateFormData({
        ...formData,
        [fieldName]: value,
      });
      setFormErrors({ ...formErrors, [fieldName]: "" });
    } else if (typeof eOrValue === "object" && eOrValue?.value !== undefined) {
      updateFormData({
        ...formData,
        [name]: eOrValue.value,
      });
      setFormErrors({ ...formErrors, [name]: "" });
    }
  };

  const handleFormSubmit = (event) => {
    event.preventDefault();
    setMessage("");
    setErrorMessage("");

    if (/\s/.test(formData.programManagerCode)) {
      setFormErrors({
        ...formErrors,
        programManagerCode: "Program Manager Code cannot contain spaces",
      });
      return;
    }

    const errors = formValidation(formData, [
      "programManagerName",
      "programManagerCode",
      "consentRequired",
    ]);
    if (!!errors && Object.keys(errors).length !== 0) {
      setFormErrors(errors);
      return;
    }

    const successHandler = (res) => {
      if (res && res?.data?.code === "0000") {
        setMessage("Program Manager saved successfully");
        setDataSet(Date.now());
        setProgramManagerId(res?.data?.id);
        updateFormData(formField);
      } else {
        setErrorMessage(res?.msg || "Something went wrong");
        setDataSet(Date.now());
      }
    };

    const errorHandler = (err) => {
      setErrorMessage(err?.message || "Something went wrong");
      setDataSet(Date.now());
    };

    const api = new ApiRequest("", successHandler, errorHandler, false);
    return api.post(`${Config.apis.admin.CREATE_PROGRAM}`, formData);
  };

  const formInner = (
    <>
      <Heading as="h2" size="md" color="color2">
        ENTER PROGRAM MANAGER INFORMATION
      </Heading>
      <br />
      {message ? <SuccessMessage successMessage={message} dataset={dataset} /> : null}
      {errorMessage ? <ErrorMessage error={errorMessage} datetimestamp={dataset} /> : null}

      <form className={isV2 ? "" : "mt32"} onSubmit={handleFormSubmit} style={isV2 ? { marginTop: theme.spacing.md } : undefined}>
        <div className="flex flex-center gap28 mb20">
          <MaterialInput
            name="programManagerName"
            value={formData.programManagerName}
            onChange={handleFormDataChange}
            type="text"
            placeholder="Program Manager Name"
            error={formErrors.programManagerName}
          />
        </div>

        <div className="flex flex-center gap28 mb20">
          <MaterialInput
            name="programManagerCode"
            value={formData.programManagerCode}
            onChange={handleFormDataChange}
            type="text"
            placeholder="Program Manager Code"
            error={formErrors.programManagerCode}
          />
        </div>

        <div className="flex flex-center gap28 mb20">
          <MaterialInput
            name="consentRequired"
            value={
              formData.consentRequired
                ? {
                    label: formData.consentRequired === "true" ? "Yes" : "No",
                    value: formData.consentRequired,
                  }
                : null
            }
            onChange={(option) => handleFormDataChange(option, "consentRequired")}
            type="select"
            placeholder="Consent Required"
            error={formErrors.consentRequired}
            options={[
              { label: "Yes", value: "true" },
              { label: "No", value: "false" },
            ]}
          />
        </div>
        <div className="flex flex-center gap28 mb20">
          <label style={{ fontSize: "16px", marginRight: "10px" }}>Cashback Required</label>

          <label className="switch">
            <input
              type="checkbox"
              checked={formData.cashbackRequired}
              onChange={(e) =>
                handleFormDataChange({
                  target: { name: "cashbackRequired", value: e.target.checked },
                })
              }
            />
            <span className="slider round"></span>
          </label>
        </div>

        <ButtonSolid width="320px" primary xl type="submit" className="mt20">
          CREATE
        </ButtonSolid>
      </form>
    </>
  );

  return (
    <>
      <Heading size="xxl" className="mt32">
        Create Program Manager
      </Heading>
      <ViewAdminWrapper className="mt50">{formInner}</ViewAdminWrapper>
    </>
  );
}
